import { FC, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Singleton } from "../../core/services/Singleton";
import { RouterAdmin } from "../admin/RouterAdmin";
import { RouterContract } from "../RouterContract";
import { RouterBpm } from "../RouterBpm";
import { RouterSupplier } from "../RouterSupplier";
import { MenuModulo } from "../theme/menu/MenuModulo";
import { NotPermision } from "../theme/NotPermision";
import { RouterAdminService } from "../RouterAdminService";
import { RouterInteres } from "../RouterInteres";
import { CreditRouter } from "../custom/forpo/CreditRouter";
import { HamburguerMenu } from "../admin/menu/HamburguerMenu";
import "react-toastify/dist/ReactToastify.css";
import SessionTimeout from "../theme/Component/SessionTimeout";
import { RouterResources } from "../RouterResources";
import { SystemUtil } from "../system/SystemUtil";
import { RouterAbstractAction } from "../RouterAbstractAction";
import { RouterHumanResources } from "../RouterHumanResources";
import { RouterFactory } from "../RouterFactory";
import { Spinner } from "../../core/components/Spinner";
import { AdminService } from "../../core/services/AdminService";
import { RouterBudget } from "../RouterBudget";
import { _single } from "../../core/services/dataBean/EntityCatalog";
import { Dashed } from "./DefaultHomePage/Dashed/Dashed";
import { DefaultHome } from "./DefaultHomePage/DefaultHome";
import { RouterManagerActivity } from "../RouterManagerActivity";
import { QueueProvider } from "../theme/Component/ValidationDocumentQueue/QueueProvider";
import { RouterDocumentManager } from "../RouterDocumentManager";
import { env } from "../../env";

interface Props {
  setIsLogged: any;
  notFound: boolean;
}

export const Home: FC<Props> = ({ setIsLogged, notFound }) => {

  const isTest = env.TEST_ENVIROMENT ?? false;
  const miga = useParams();
  const { module, view, param } = miga;
  const adminService = new AdminService();


  const safeInitIsMobile =
    typeof window !== "undefined"
      ? window.matchMedia?.("(max-width: 990.40px)")?.matches ?? (window.innerWidth <= 990.40)
      : false;

  const [user, setUser] = useState<any>({});
  const [isMobile, setIsMobile] = useState(safeInitIsMobile);
  const [menuOpen, setMenuOpen] = useState(!safeInitIsMobile);

  const navigate = useNavigate();

  useEffect(() => {
    let user = _single.getAccount() || {};

    if (user.IDAccount) {
      setUser(user);
      getAccountInfo();
    } else {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;

      _single.setWindowSize(w, h);

      const mobileView = _single.getIsMovil();
      setIsMobile(mobileView);
      setMenuOpen(!mobileView);
    };


    handleResize();

    window.addEventListener("resize", handleResize);
    window.visualViewport?.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.visualViewport?.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (!isMobile) setMenuOpen(true);
  }, [module, isMobile]);

  const getAccountInfo = () => {
    if (_single.getAccountID() > 0)
      adminService.getAccountInfo(_single.getAccountID()).subscribe(
        (resp: any) => {
          if (resp.DataBeanProperties.ObjectValue) {
            _single.pushAccountInfo(resp.DataBeanProperties.ObjectValue);
          }
        }
      );
  };

  const permitURL = [
    "admin/bandeja-mensajes",
    "admin/perfil",
    "admin/user-inbox",
    "bpm/ibox2",
    "admin/miscursos",
    "admin/calendar",
    "admin/dashBoard",
    "admin/module-properties",
    "admin/parametricas",

  ];


  const renderSwitch = (url: any, vi: any) => {

    if (module === undefined && view === undefined) {
      url = "admin";
    } else if (permitURL.includes(module + "/" + view)) {

      let permiso = !true;
      if (permiso) url = "restrict";

    } else if (param) {
      let permiso = !_single.havePermision64(param);
      if (permiso) url = "restrict";

    } else {
      url = "restrict";
    }

    // if (module !== undefined && view !== undefined)
    //   _single.view("Ingreso : " + "/" + module + "/" + view, null);

    //   _single.view("Ingreso : " + "/" + module + "/" + view, null);
    console.log("Ingreso : " + "/" + url + "/" + vi);


    switch (url) {
      case "admin":
        return <RouterAdmin ruta={view} prop={param} />;
      case "contratos":
        return <RouterContract ruta={view} />;
      case "bpm":
        return <RouterBpm ruta={view} />;
      case "supplier":
        return <RouterSupplier ruta={view} />;
      case "servicios":
        return <RouterAdminService ruta={view} />;
      case "resources":
        return <RouterResources ruta={view} />;
      case "interes":
        return <RouterInteres />;
      case "talento-humano":
        return <RouterHumanResources />;
      case "budget":
        return <RouterBudget />;
      case "factory":
        return <RouterFactory />;
      case "manager":
        return <RouterManagerActivity view={view} />;
      case "remote-abstract-action":
        return <RouterAbstractAction />;
      case "credit":
        return <CreditRouter  />;
      case "restrict":
        return <NotPermision />;
      case "documentos":
        return <RouterDocumentManager />;
      case "system":
        return <SystemUtil view={view} />;
      default:
        return <DefaultHome />;
    }
  };

  const logout = () => {
    Singleton.getInstance().closeSesion();
    navigate("/login");
  };

  return (
    <>

      <Spinner />
      <SessionTimeout login={user.IDAccount} setIsLogged={logout} />
      <div style={{ height: isTest ? "calc(100vh - var(--test-environment-banner-height))" : "100vh", display: "flex", flexDirection: "row", overflow: "hidden", }} >

        {isMobile && (
          <div className="custom-navmenu">
            <HamburguerMenu _open={menuOpen} handleClick={() => setMenuOpen((prev) => !prev)} />
          </div>
        )}

        <div className="custom-sidermenu" style={{ flex: menuOpen ? "0 0 310px" : "0 0 0px", minWidth: menuOpen ? "310px" : "0px", borderRight: menuOpen ? "1px solid #ddd" : "none", }} >
          <MenuModulo />
        </div>

        <div className="custom-content" style={{ paddingTop: !menuOpen ? "4rem" : "2rem", }} >
          {!notFound && (
            <div className="container-fluid d-flex flex-column h-100">
              <QueueProvider>
                <div className="pb-4">
                  {renderSwitch(module, view)}
                </div>
              </QueueProvider>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
